<template>
  <div>
    <div class="header">
      <img src="../../static/logo.png" />
      <h2>支付成功</h2>
    </div>
    <div class="van-coupon-list__list" style="height: 570px;">
      <div class="van-coupon">
        <div class="van-coupon__content">
          <div class="van-coupon__head">
            <h2 class="van-coupon__amount">
              {{unit_price}}
              <span>元</span>
            </h2>
          </div>
          <div class="van-coupon__body">
            <h2 class="van-coupon__name">{{title}}</h2>
            <p>共{{num}}个</p>
          </div>
        </div>
      </div>
      <div style="color:gray;font-size:14px;text-align:center ">建议截图保留付款信息</div>
    </div>

    <div
      style="color:gray;font-size:14px;position: absolute;
  right: 0;
  left: 0;
  bottom: 10px;text-align:center"
    >技术支持:锐道咨询</div>
    <!-- <van-coupon-list :coupons="coupons" /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      unit_price: 2000,
      title: "长沙站开门红公开课",
      num: 10
    };
  },

  methods: {},
  created() {
    this.num = this.$route.query.num;
    this.title = this.$route.query.title;
    this.unit_price = this.$route.query.price;
    console.log(this.$route.query);
  }
};
</script>
<style scoped>
.header {
  text-align: center;

  margin-top: 40%;
}
</style>


// WEBPACK FOOTER //
// src/views/ttt.vue